import { render, staticRenderFns } from "./NonRegisteredDebtors.vue?vue&type=template&id=810611e4&scoped=true&"
import script from "./NonRegisteredDebtors.vue?vue&type=script&lang=js&"
export * from "./NonRegisteredDebtors.vue?vue&type=script&lang=js&"
import style0 from "./NonRegisteredDebtors.vue?vue&type=style&index=0&id=810611e4&lang=scss&scoped=true&"
import style1 from "./NonRegisteredDebtors.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810611e4",
  null
  
)

export default component.exports